import { globalNavHostCommand } from "domains/nav/constants/eventTypes";
import type { HostCommand, HostCommandPayloads } from "domains/nav/types/hostCommand";

export const executeHostCommand = <T extends HostCommand>(
  command: T,
  payload: T extends keyof HostCommandPayloads ? HostCommandPayloads[T] : undefined,
) =>
  void window.dispatchEvent(new CustomEvent(globalNavHostCommand, { detail: { _type: command, _payload: payload } }));
